import React, {useCallback, useEffect, useRef, useState} from "react";

function useReady() {
  const [ready, setIsReady] = useState(false);
  const [resolveQueue, setResolveQueue] = useState([]);

  // Function to add a promise to the queue
  const waitUntilReady = useCallback(() => {
    if (ready) {
      return Promise.resolve();
    }
    return new Promise(resolve => {
      setResolveQueue(queue => [...queue, resolve]);
    });
  }, [ready]);

  // Function to release all waiting promises
  const setReady = useCallback(() => {
    setIsReady(true);
    resolveQueue.forEach(resolve => resolve());
    setResolveQueue([]);
  }, [resolveQueue]);

  return {ready, setReady, waitUntilReady};
}

function isMobileDev() {

}

export function numberIsNotBlank(n) {
  return (typeof(n) === "number" && isFinite(n) && (n > 0))
}

export function useStateWithCallback(initialValue) {
  const [state, setState] = useState(initialValue);
  const cbRef = useRef(null);

  const setStateWithCallback = (value, callback) => {
    cbRef.current = callback;
    setState(value);
  };

  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(state);
      cbRef.current = null;
    }
  }, [state]);

  return [state, setStateWithCallback];
}

export function deepSet(obj, path, value) {
  const keys = path.split(".");
  let current = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!current[key] || typeof current[key] !== "object") {
      current[key] = {};
    }
    current = current[key];
  }

  current[keys[keys.length - 1]] = value;
}

export function optsAddTextAndDescription(opts) {
  let o = opts
  if (o) {
    o.forEach((c) => {
      if (!c.label && (c.text || c.description)) {
        c.label = (
          <>
            <div>{c.text}</div>
            {
              c.description &&
              <small>{c.description}</small>
            }
          </>
        );
      }
    });
  }
  return o;
}

export function optsSortAndAddTextAndDescription(opts) {
  let o = opts
  if (o) {
    o = o.sort((a, b) => a.text ? a.text.localeCompare(b.text) : a.label.localeCompare(b.label))
    o.forEach((c) => {
      if (!c.label && (c.text || c.description)) {
        c.label = (
          <>
            <div>{c.text}</div>
            {
              c.description &&
                <small>{c.description}</small>
            }
          </>
        );
      }
    });
  }
  return o;
}

function truncNum(num, decimals = 0) {
  const factor = 10 ** decimals;
  return Math.trunc(num * factor) / factor;
}

export function ceilNum(num) {
  return Math.ceil(num * 100) / 100;
}


export function getPropertyComputedValue(property) {
  const skinEl = document.documentElement
  const styles = window.getComputedStyle(skinEl)
  for (let i = 0; i < styles.length; i++) {
    const prop = styles[i];
    // if (prop.startsWith('--app')) {
    //   console.log(">>>Z: var=", prop, styles.getPropertyValue(prop).trim())
    // }
  }
  if (Array.isArray(property)) {
    const result = {}
    for (const n of property) {
        result[n] = window.getComputedStyle(skinEl).getPropertyValue(n)
    }
    return result
  }
  else {
    return window.getComputedStyle(skinEl).getPropertyValue(property)
  }
}

export function mkBrandName(brandName, cobrandName) {
  return cobrandName ? `${brandName}-${cobrandName}` : brandName
  // return cobrandName ? `${cobrandName}-${brandName}` : brandName
}

function detectTheme() {
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return "dark"
  }
  else {
    return "light"
  }
}

export function determineTheme(theme) {
  const t = theme?.toLowerCase()?.trim() || "auto"
  if (["dark", "light"].includes(t)) {
    return theme
  }
  else if (t.endsWith("-dark") || t.endsWith("-light")) {
    return theme
  }
  else {
    return detectTheme()
  }
}

export function cssStringToObject(cssString) {
  if (!cssString || typeof cssString !== 'string') return {};

  const result = {};
  const declarations = cssString.split(';');

  for (const declaration of declarations) {
    const trimmed = declaration.trim();
    if (!trimmed) continue;

    const colonIndex = trimmed.indexOf(':');
    if (colonIndex === -1) continue;

    const prop = trimmed.substring(0, colonIndex).trim();
    const val = trimmed.substring(colonIndex + 1).trim();

    const camelProp = prop.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
    result[camelProp] = val;
  }

  return result;

}

export function isObject(val) {
  return (typeof val === 'object' && val !== null && !Array.isArray(val))
}

export function isNonEmptyObject(val) {
  return typeof val === 'object' && val !== null && !Array.isArray(val) && Object.keys(val).length > 0;
}

export function isArray(val) {
  return val != null && Array.isArray(val);
}

export function isNonEmptyArray(val) {
  return Array.isArray(val) && val.length > 0;
}

export const onlyDigits = (s) => String(s == null ? "" : s).replace(/\D/g, "");


